import React, { Component } from "react";
import "./ForgotPassword.css";
import { forgotPassword, signup, verify } from "../../util/APIUtils";
import { Link, Redirect } from "react-router-dom";
import Alert from "react-s-alert";
import { CLIENT } from "../../constants";

class ForgotPassword extends Component {
  constructor() {
    super();
    this.state = {
      checkSuccess: false,
    };
  }

  componentDidMount() {
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get("token");
    // verify(code)
    //     .then(response => {
    //         Alert.success("Congratulations, your account has been verified.");
    //         this.setState({
    //             checkSuccess: true
    //         });
    //     }).catch(error => {
    //     // this.props.history.push("/signup");
    //     // Alert.error((error && error.message) || 'Sorry, we could not verify account. It maybe already verified, or verification code is\n' +
    //     //     '                    incorrect.');
    // });

    // If the OAuth2 login encounters an error, the user is redirected to the /login page with an error.
    // Here we display the error and then remove the error query parameter from the location.
    if (this.props.location.state && this.props.location.state.error) {
      setTimeout(() => {
        Alert.error(this.props.location.state.error, {
          timeout: 5000,
        });
        this.props.history.replace({
          pathname: this.props.location.pathname,
          state: {},
        });
      }, 100);
    }
  }

  render() {
    if (this.props.authenticated) {
      return (
        <Redirect
          to={{
            pathname: "/",
            state: { from: this.props.location },
          }}
        />
      );
    }

    return (
      <div className="signup-container">
        <div className="signup-content">
          <h1 className="signup-title">Reset Password</h1>
          <ForgotPasswordForm {...this.props} />
          <span className="login-link">
            Already have an account? <Link to="/login">Login!</Link>
          </span>
        </div>
      </div>
    );
  }
}

class ForgotPasswordForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.loadCurrentlyClient = this.loadCurrentlyClient.bind(this);
  }

  loadCurrentlyClient() {
    // var client = localStorage.getItem(CLIENT);
    // console.log(client);
    // if (this.props.hasOwnPropert("client")) {
    //     this.setState({
    //         clientId: this.props.client.clientId
    //     });
    // } else {
    //     this.setState({
    //         clientId: JSON.parse(client)
    //     });
    // }
  }

  handleInputChange(event) {
    const target = event.target;
    const inputName = target.name;
    const inputValue = target.value;

    this.setState({
      [inputName]: inputValue,
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const forgotPasswordRequest = Object.assign({}, this.state);
    forgotPassword(forgotPasswordRequest)
      .then((response) => {
        // console.logl('success')
        Alert.success("Please check your email to change your password!");

        var newURL = `/resend-verify-email?email=${this.state.email}`;
        this.props.history.push(newURL);
      })
      .catch((error) => {
        Alert.error(
          (error && error.message) ||
            "Oops! Something went wrong. Please try again!"
        );
      });
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <div className="form-item">
          <input
            type="email"
            name="email"
            className="form-control"
            placeholder="Email"
            value={this.state.email}
            onChange={this.handleInputChange}
            required
          />
        </div>
        <div className="form-item">
          <button type="submit" className="btn-8">
            <span>Forgot Password</span>
          </button>
        </div>
      </form>
    );
  }
}

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/user/forgot_password/ForgotPassword.js